module.exports = __webpack_public_path__ + "img/3-1.98124839.png";